import D2C_TariffExtraMembers from './ExtraMembers'
import D2C_TariffExtraMembersAnnual from './ExtraMembersAnnual'
import D2C_TariffFree from './Free'
import D2C_TariffOption from './Option'
import D2C_TariffPersonal from './Personal'
import D2C_TariffPersonalAnnual from './PersonalAnnual'
import D2C_TariffStarter from './Starter'
import D2C_TariffStarterAnnual from './StarterAnnual'
import D2C_TariffPlan from './Plan'
import D2C_TariffEarlyBird from './EarlyBird'
import D2C_TariffEarlyBirdAnnual from './EarlyBirdAnnual'
import D2C_TariffBusiness from './Business'
import D2C_TariffBusinessAnnual from './BusinessAnnual'

export default {
  TariffExtraMembers: D2C_TariffExtraMembers,
  TariffExtraMembersAnnual: D2C_TariffExtraMembersAnnual,
  TariffFree: D2C_TariffFree,
  TariffOption: D2C_TariffOption,
  TariffPersonal: D2C_TariffPersonal,
  TariffPersonalAnnual: D2C_TariffPersonalAnnual,
  TariffStarter: D2C_TariffStarter,
  TariffStarterAnnual: D2C_TariffStarterAnnual,
  TariffPlan: D2C_TariffPlan,
  TariffEarlyBird: D2C_TariffEarlyBird,
  TariffEarlyBirdAnnual: D2C_TariffEarlyBirdAnnual,
  TariffBusiness: D2C_TariffBusiness,
  TariffBusinessAnnual: D2C_TariffBusinessAnnual,
}
